import React, { useContext } from "react";
import CatalogItemService from "../../../services/CatalogItemService";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IPrice_Group from "../../../models/IPrice_Group";
import SupplierContext from "../../../contexts/SupplierContext";
import IOrder_Item from "../../../models/IOrder_Item";
import * as _ from "lodash-es";

type Props = {
    catalogItem: ICatalog_Item;
    priceGroup?: IPrice_Group;
    orderItem?: IOrder_Item;
};

export const CatalogItemDescription = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    let description = props.catalogItem.description;

    if (supplierModel.has_pricing_descriptions) {
        if (props.priceGroup) {
            const pricingDescriptions = props.catalogItem.pricing_descriptions;

            if (
                pricingDescriptions &&
                _.isString(pricingDescriptions[props.priceGroup.value]) &&
                pricingDescriptions[props.priceGroup.value].length
            ) {
                description = pricingDescriptions[props.priceGroup.value];
            }
        }
    }

    if (props.orderItem) {
        if (props.orderItem.description) {
            description = props.orderItem.description;
        }
    }

    return <div className={"text-break"} dangerouslySetInnerHTML={{ __html: description || "" }}></div>;
};
